<template>

  <div>

      <div class="level is-mobile">

        <div class="level-left">
            <div class="level-item">
              <span>{{label}}</span>&nbsp;<b-tag v-if="tag" type="is-warning">{{tag}}</b-tag>
            </div>
        </div>

        <div class="level-right">
            <div class="level-item">
              {{valueLabel}}
            </div>
        </div>
        
      </div>
    
      <input @change="updateSetting" type="range" step="1" list="steplist" :min="maxMin[0]" :max="maxMin[1]" v-model="value" class="slider">

  </div>

</template>

<script>

  import { mapGetters, mapActions } from "vuex";

  export default {

    name: 'RangeSlider',

    props: ['name',  'label', 'maxMin', 'formatter', 'tag', 'value', 'icon', 'default', 'applyTo'],

    data:function(){
      return{
      }
    },

    computed : {

      valueOrDefault(){        
        return (this.value)?this.value:this.default;
      },

      valueLabel(){
        return this.value * this.formatter.factor + " " + this.formatter.unit;
      }

    },

    methods:{

      updateSetting(e){
        this.$emit('change', {name:this.name, value:e.target.value});
      }

    }
 
  }
    
</script>

<style scoped>

  .slider {
  -webkit-appearance: none;
  width: 100%;
  display: block;
  height: 1em;
  border-radius: 1em;   
  padding:0.2em;
  margin:0.4em 0;
  background: #363636;
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 2.4em;
  height: 2.4em;
  border-radius: 50%; 
  background: whitesmoke;
  cursor: pointer;
  border:0.2em solid #363636;
}

.slider::-moz-range-thumb {
  width: 2.4em;
  height: 2.4em;
  border-radius: 50%;
  background: whitesmoke;
  cursor: pointer;
  border:0.2em solid #363636;
}

</style>
